import { axios } from 'lib/axios';

export const loginWithGoogle = ({ code }) => {
  return axios.get(`/v2/oauth/google/callback?code=${code}`);
};
